



















































import { Fragment } from 'vue-fragment';
import Vue from 'vue';

export default Vue.extend({
    name: 'tab-item',
    components: { Fragment },
    props: {
        title: {
            type: String,
            required: true,
        },
        defaultItem: Boolean,
    },
});
